function boundedNumber(value, fallback, minimum, maximum) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= minimum && parsed <= maximum
    ? parsed
    : fallback;
}

export const saleLocationPolicy = Object.freeze({
  maxAccuracyMeters: boundedNumber(
    process.env.REACT_APP_SALE_LOCATION_MAX_ACCURACY_METERS,
    100,
    5,
    250,
  ),
  prewarmMaxAgeMs: boundedNumber(
    process.env.REACT_APP_SALE_LOCATION_PREWARM_MAX_AGE_MS,
    15_000,
    1_000,
    30_000,
  ),
});

export function evaluateSaleLocation(location, policy = saleLocationPolicy) {
  if (location?.mocked) return "mocked";
  if (
    !Number.isFinite(location?.accuracyMeters) ||
    location.accuracyMeters <= 0 ||
    location.accuracyMeters > policy.maxAccuracyMeters
  ) {
    return "imprecise";
  }
  return null;
}
